@if (fundRaiseProcess) {
  <div class="table-container table-responsive">
    <table class="table">
      <thead>
        <tr class="title">
          <th id="title" class="text-black-50" width="50%">
            {{ 'common.item' | translate }}
          </th>
          <th id="lastUpdatedDate" class="text-black-50" width="30%">
            {{ 'raise.lastUpdatedOn' | translate }}
          </th>
          <th id="raiseFundApplicationProcessStatusType" class="text-black-50" width="20%">
            {{ 'common.status' | translate }}
          </th>
        </tr>
        <tr class="header">
          <th id="title">
            <div class="d-flex flex-row align-items-center">
              <div
                class="pitchin-icon-md pitchin-icon-check-grey mr-4"
                [class.pitchin-icon-check-green]="
                  fundRaiseProcess.raiseFundApplicationProcessStatusType ==
                  RaiseFundApplicationProcessStatusType.Approved
                "
              ></div>
              <span>{{ tabContent.title | translate }}</span>
            </div>
          </th>
          <th id="lastUpdatedDate">
            @if (!isDraftProcess()) {
              <div class="font-weight-normal">
                {{
                  (fundRaiseProcess.lastUpdatedDate | amDateFormat: 'DD MMM YYYY, HH:mm a') || '-'
                }}
              </div>
            } @else {
              -
            }
          </th>
          <th id="raiseFundApplicationProcessStatusType">
            @if (
              fundRaiseProcess.raiseFundApplicationProcessStatusType ==
              RaiseFundApplicationProcessStatusType.Approved
            ) {
              @switch (tabContent.tab) {
                @case (RaiseFundApplicationProcessModule.FundRaiseApplication) {
                  <button type="btn" class="btn btn-tertiary btn-lg" (click)="nextStep()">
                    {{ tabContent.btnText | translate }}
                  </button>
                }
                @case (RaiseFundApplicationProcessModule.DueDiligence) {
                  <button type="btn" class="btn btn-tertiary btn-lg" (click)="nextStep()">
                    {{ tabContent.btnText | translate }}
                  </button>
                }
                @case (RaiseFundApplicationProcessModule.OfferCreation) {
                  @if (!campaignCreated) {
                    <button
                      type="btn"
                      class="btn btn-tertiary btn-lg"
                      [routerLink]="['/raise/new-campaign', fundRaiseApplicationId]"
                    >
                      {{ tabContent.btnText | translate }}
                    </button>
                  }
                  @if (campaignCreated) {
                    <button type="btn" class="btn btn-tertiary btn-lg" (click)="nextStep()">
                      {{ 'raise.proceedToCampaignCreation' | translate }}
                    </button>
                  }
                }
              }
            }
            @if (
              tabContent.tab == RaiseFundApplicationProcessModule.CreateCampaign &&
              fundRaiseProcess?.items[0]?.campaignId &&
              !isDraftProcess()
            ) {
              <button
                type="btn"
                class="btn btn-tertiary btn-lg"
                [routerLink]="[
                  '/raise/campaign-details',
                  fundRaiseApplicationId,
                  fundRaiseProcess.items[0].campaignId,
                ]"
              >
                {{ tabContent.btnText | translate }}
              </button>
            }
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Required for Pre-live -->
        @if (requiredForPreLiveItems.length > 0) {
          <tr>
            <td colspan="3" class="group-header-td !tw-p-0">
              <div class="group-header">{{ 'raise.requiredForPreLive' | translate }}</div>
            </td>
          </tr>
          @for (item of requiredForPreLiveItems; track item) {
            <ng-template *ngTemplateOutlet="desktopList; context: { item: item }"></ng-template>
          }
        }
        <!-- Required for Live -->
        @if (requiredForLiveItems.length > 0) {
          <tr>
            <td colspan="3" class="group-header-td !tw-p-0">
              <div class="group-header">{{ 'raise.requiredForLive' | translate }}</div>
            </td>
          </tr>
          @for (item of requiredForLiveItems; track item) {
            <ng-template *ngTemplateOutlet="desktopList; context: { item: item }"></ng-template>
          }
        }
        <!-- Other without requirements (mainly for non-DD tab) -->
        @if (noRequirementItems.length > 0) {
          @for (item of noRequirementItems; track item) {
            <ng-template *ngTemplateOutlet="desktopList; context: { item: item }"></ng-template>
          }
        }
        <!-- Optional -->
        @if (optionalItems.length > 0) {
          <tr>
            <td colspan="3" class="group-header-td !tw-p-0">
              <div class="group-header">{{ 'raise.optional' | translate }}</div>
            </td>
          </tr>
          @for (item of optionalItems; track item) {
            <ng-template *ngTemplateOutlet="desktopList; context: { item: item }"></ng-template>
          }
        }
      </tbody>
    </table>
  </div>
  <div class="list-container">
    <div class="list-header">
      <div class="d-flex flex-row">
        <div
          class="pitchin-icon-md pitchin-icon-check-grey mr-4"
          [class.pitchin-icon-check-green]="fundRaiseProcess.isCompleted"
        ></div>
        <div>
          <div class="font-weight-bold">{{ tabContent.title | translate }}</div>
          @if (fundRaiseProcess.lastUpdatedDate) {
            <div>
              {{ fundRaiseProcess.lastUpdatedDate | amDateFormat: 'DD MMM YYYY, HH:mm a' }}
            </div>
          }
          @if (fundRaiseProcess.isCompleted) {
            <button type="btn" class="btn btn-tertiary btn-lg mt-2" (click)="nextStep()">
              {{ tabContent.btnText | translate }}
            </button>
          }
        </div>
      </div>
    </div>
    <!-- Required for Pre-Live -->
    @if (requiredForPreLiveItems.length > 0) {
      <div class="group-header--mobile">{{ 'raise.requiredForPreLive' | translate }}</div>
      @for (item of requiredForPreLiveItems; track item) {
        <div class="list-body">
          <ng-template *ngTemplateOutlet="mobileList; context: { item: item }"></ng-template>
        </div>
      }
    }
    <!-- Required for Live -->
    @if (requiredForLiveItems.length > 0) {
      <div class="group-header--mobile">{{ 'raise.requiredForLive' | translate }}</div>
      @for (item of requiredForLiveItems; track item) {
        <div class="list-body">
          <ng-template *ngTemplateOutlet="mobileList; context: { item: item }"></ng-template>
        </div>
      }
    }
    <!-- Required for Optional -->
    @if (optionalItems.length > 0) {
      <div class="group-header--mobile">{{ 'raise.optional' | translate }}</div>
      @for (item of optionalItems; track item) {
        <div class="list-body">
          <ng-template *ngTemplateOutlet="mobileList; context: { item: item }"></ng-template>
        </div>
      }
    }
    <!-- No requirement -->
    @if (noRequirementItems.length > 0) {
      @for (item of noRequirementItems; track item) {
        <div class="list-body">
          <ng-template *ngTemplateOutlet="mobileList; context: { item: item }"></ng-template>
        </div>
      }
    }
  </div>
}

<ng-template #desktopList let-item="item">
  <ng-template *ngTemplateOutlet="row; context: { item: item }"></ng-template>
  @if (tabContent.tab != RaiseFundApplicationProcessModule.OfferCreation) {
    @for (subItem of item.subItems; track subItem) {
      <ng-template
        *ngTemplateOutlet="row; context: { item: subItem, padding: 'pl-5', parent: item }"
      >
      </ng-template>
      @if (subItem.subItems?.length > 0) {
        @for (sub of subItem.subItems; track sub) {
          <ng-template
            *ngTemplateOutlet="row; context: { item: sub, padding: 'pl-6', parent: subItem }"
          >
          </ng-template>
        }
      }
    }
  }
</ng-template>

<ng-template #mobileList let-item="item">
  <ng-template *ngTemplateOutlet="mobilerow; context: { item: item }"></ng-template>
  @if (tabContent.tab != RaiseFundApplicationProcessModule.OfferCreation) {
    @for (subItem of item.subItems; track subItem) {
      <ng-template
        *ngTemplateOutlet="mobilerow; context: { item: subItem, padding: 'pl-5', parent: item }"
      >
      </ng-template>
      @for (sub of subItem.subItems; track sub) {
        <ng-template
          *ngTemplateOutlet="mobilerow; context: { item: sub, padding: 'pl-5', parent: subItem }"
        >
        </ng-template>
      }
    }
  }
</ng-template>

<ng-template #row let-item="item" let-padding="padding" let-parent="parent">
  <tr>
    <td scope="row">
      <div class="row {{ padding }}">
        <div class="col-1">
          <div
            class="pitchin-icon-md pitchin-icon-check-grey mr-4"
            [class.pitchin-icon-check-green]="
              [
                RaiseFundApplicationProcessStatusType.Approved,
                RaiseFundApplicationProcessStatusType.Paid,
              ].includes(item.raiseFundApplicationProcessStatusType)
            "
            [class.pitchin-icon-rejected-icon-red]="
              item.raiseFundApplicationProcessStatusType ==
              RaiseFundApplicationProcessStatusType.Rejected
            "
          ></div>
        </div>
        <div class="col-11 align-self-center">
          <div class="d-flex flex-column">
            <div [innerHTML]="item.title"></div>
            <ng-template *ngTemplateOutlet="detail; context: { item: item }"></ng-template>
            @if (
              item.raiseFundApplicationActionType != RaiseFundApplicationActionType.UploadReceipt &&
              item.sampleAttachmentUrl &&
              !item.attachment
            ) {
              <div class="link" (click)="viewDetails(item.sampleAttachmentUrl)">
                {{ 'raise.downloadTemplate' | translate }}
              </div>
            }
          </div>
        </div>
      </div>
    </td>
    <td>
      @if (!isDraftItem(item)) {
        <div class="font-weight-normal">
          {{ (item.lastUpdatedDate | amDateFormat: 'DD MMM YYYY, HH:mm a') || '-' }}
        </div>
      } @else {
        -
      }
    </td>
    <td>
      <ng-template
        *ngTemplateOutlet="action; context: { item: item, parent: parent }"
      ></ng-template>
    </td>
  </tr>
</ng-template>

<ng-template #detail let-item="item">
  @if (item.raiseFundApplicationProcessStatusType != RaiseFundApplicationActionType.None) {
    @switch (item.raiseFundApplicationActionType) {
      @case (RaiseFundApplicationActionType.DynamicForm) {
        @if (
          [
            RaiseFundApplicationProcessModule.FundRaiseApplication,
            RaiseFundApplicationProcessModule.DueDiligence,
          ].includes(tabContent.tab)
        ) {
          <div
            class="link"
            [routerLink]="
              'detail/' +
              fundRaiseApplicationId +
              '/steps/' +
              item.id +
              '/submission/' +
              item.dynamicFormSubmissionId
            "
          >
            {{ 'common.viewDetails' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.OfferCreation) {
        <div class="link" [routerLink]="['/raise/offer-creation', fundRaiseApplicationId]">
          {{ 'common.viewDetails' | translate }}
        </div>
      }
      @case (RaiseFundApplicationActionType.CreateCampaign) {
        @if (
          tabContent.tab == RaiseFundApplicationProcessModule.CreateCampaign && !isDraftItem(item)
        ) {
          <div
            class="link"
            [routerLink]="['/raise/campaign-details', fundRaiseApplicationId, item.campaignId]"
          >
            {{ 'common.viewDetails' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.CreateSummaryPage) {
        @if (
          tabContent.tab == RaiseFundApplicationProcessModule.CreateCampaign &&
          !isDraftItem(item) &&
          (item.campaignId ?? campaignId) != null
        ) {
          <div
            class="link"
            [routerLink]="['/raise/one-pager-preview', item.campaignId ?? campaignId]"
          >
            {{ 'common.view' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.Ekyc) {
        <div class="link" [routerLink]="['/ekyc/detail']">
          {{ 'common.viewDetails' | translate }}
        </div>
      }
      @case (RaiseFundApplicationActionType.UploadDocument) {
        @if (item.attachment) {
          <div class="link" (click)="viewDetails(item.attachment.url)">
            {{ 'common.viewDetails' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.Attachment) {
        @if (item.attachment) {
          <div class="link" (click)="viewDetails(item.attachment.url)">
            {{ 'common.viewDetails' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.UploadCampaignVideo) {
        @if (item.attachment) {
          <div class="link" (click)="viewDetails(item.attachment.url)">
            {{ 'common.viewVideo' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.UploadReceipt) {
        @if (item.attachment) {
          <div class="link" (click)="viewDetails(item.attachment.url)">
            {{ 'common.viewReceipt' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.FPXPayment) {
        @if (item.paymentGatewayReferenceNumber) {
          <div
            class="link"
            [routerLink]="'/raise-fund-receipt/' + item.paymentGatewayReferenceNumber"
          >
            {{ 'common.viewReceipt' | translate }}
          </div>
        }
      }
    }
  }
</ng-template>

<ng-template #action let-item="item" let-parent="parent">
  @if (
    (item.raiseFundApplicationProcessStatusType != RaiseFundApplicationProcessStatusType.None ||
      item.raiseFundApplicationActionType == RaiseFundApplicationActionType.CreateCampaign ||
      item.raiseFundApplicationActionType == RaiseFundApplicationActionType.CreateSummaryPage) &&
    ![
      RaiseFundApplicationActionType.UploadReceipt,
      RaiseFundApplicationActionType.Attachment,
    ].includes(item.raiseFundApplicationActionType)
  ) {
    <div
      class="d-flex flex-row align-items-center"
      [class.approved]="
        [
          RaiseFundApplicationProcessStatusType.Approved,
          RaiseFundApplicationProcessStatusType.Paid,
          RaiseFundApplicationProcessStatusType.BypassPayment,
        ].includes(item.raiseFundApplicationProcessStatusType)
      "
      [class.pending]="
        [
          RaiseFundApplicationProcessStatusType.Pending,
          RaiseFundApplicationProcessStatusType.PendingIssuerApproval,
          RaiseFundApplicationProcessStatusType.PendingPayment,
          RaiseFundApplicationProcessStatusType.PendingFPXApproval,
        ].includes(item.raiseFundApplicationProcessStatusType)
      "
      [class.rejected]="
        [
          RaiseFundApplicationProcessStatusType.Rejected,
          RaiseFundApplicationProcessStatusType.RejectedByIssuer,
        ].includes(item.raiseFundApplicationProcessStatusType)
      "
      [class.text-muted]="
        item.raiseFundApplicationProcessStatusType == RaiseFundApplicationProcessStatusType.None &&
        item.raiseFundApplicationActionType == RaiseFundApplicationActionType.CreateCampaign
      "
    >
      <div class="d-flex flex-row align-items-center w-100">
        <div class="d-flex flex-row align-items-center mr-3">
          <i class="fa fa-circle mr-2"></i>
          <div>
            @if (
              !isDraftItem(item) ||
              item.raiseFundApplicationActionType == RaiseFundApplicationActionType.CreateSummaryPage
            ) {
              @if (
                [
                  RaiseFundApplicationProcessStatusType.None,
                  RaiseFundApplicationProcessStatusType.Draft,
                ].includes(item.raiseFundApplicationProcessStatusType)
              ) {
                @if (
                  item.raiseFundApplicationActionType ==
                  RaiseFundApplicationActionType.CreateSummaryPage
                ) {
                  {{ 'raise.PendingAdminToCreate' | translate }}
                } @else {
                  {{ 'raise.Draft' | translate }}
                }
              } @else {
                @if (
                  item.raiseFundApplicationActionType ==
                    RaiseFundApplicationActionType.CreateSummaryPage &&
                  item.raiseFundApplicationProcessStatusType ==
                    RaiseFundApplicationProcessStatusType.Pending
                ) {
                  {{ 'raise.PendingIssuerApproval' | translate }}
                } @else {
                  {{
                    'raise.' +
                      RaiseFundApplicationProcessStatusType[
                        item.raiseFundApplicationProcessStatusType
                      ] | translate
                  }}
                }
              }
            } @else {
              <span>-</span>
            }
          </div>
        </div>
        @if (
          item.campaignId &&
          item.raiseFundApplicationActionType == RaiseFundApplicationActionType.CreateCampaign &&
          item.raiseFundApplicationProcessStatusType == RaiseFundApplicationProcessStatusType.None &&
          !isDraftItem(item)
        ) {
          <a
            class="btn btn-outline-primary btn-sm ml-3"
            [routerLink]="['/raise/edit-campaign', fundRaiseApplicationId, item.campaignId]"
          >
            {{ 'common.edit' | translate }}
          </a>
        }
        <!-- FRC-869 Withdraw a submitted campaign page while it is still pending admin review.
             Mutually exclusive with the Edit button above, which only shows once back in draft. -->
        @if (
          tabContent.tab == RaiseFundApplicationProcessModule.CreateCampaign &&
          item.raiseFundApplicationActionType == RaiseFundApplicationActionType.CreateCampaign &&
          item.campaignId &&
          item.raiseFundApplicationProcessStatusType ==
            RaiseFundApplicationProcessStatusType.Pending
        ) {
          <button
            type="button"
            class="btn btn-outline-primary btn-sm ml-3"
            (click)="cancelSubmission(item)"
          >
            {{ 'raise.withdrawSubmission' | translate }}
          </button>
        }
      </div>
    </div>
    @if (
      !isDraftItem(item) &&
      item.raiseFundApplicationProcessStatusType !=
        RaiseFundApplicationProcessStatusType.PendingIssuerApproval
    ) {
      <div class="mb-2 lastReviewedDate">
        {{ item.lastReviewedDate | amDateFormat: 'DD MMM YYYY, HH:mm a' }}
      </div>
    }
    @if (
      item.raiseFundApplicationProcessStatusType == RaiseFundApplicationProcessStatusType.Paid &&
      fundRaiseProcess.paymentRef
    ) {
      <div class="text-black-50">#{{ fundRaiseProcess.paymentRef }}</div>
    }
    @if (
      [
        RaiseFundApplicationProcessStatusType.Rejected,
        RaiseFundApplicationProcessStatusType.RejectedByIssuer,
      ].includes(item.raiseFundApplicationProcessStatusType)
    ) {
      @if (item.remark) {
        <div class="text-black-50">{{ 'raise.remark' | translate }} :</div>
        <div class="mb-3">{{ item.remark }}</div>
      }
    }
  }
  @if (
    item.raiseFundApplicationProcessStatusType == RaiseFundApplicationProcessStatusType.None ||
    item.raiseFundApplicationProcessStatusType == RaiseFundApplicationProcessStatusType.Rejected
  ) {
    @if (item.raiseFundApplicationActionType == RaiseFundApplicationActionType.DynamicForm) {
      <button
        type="btn"
        class="btn btn-outline-primary"
        [routerLink]="
          item.raiseFundApplicationProcessStatusType ==
          RaiseFundApplicationProcessStatusType.Rejected
            ? 'form/' +
              fundRaiseApplicationId +
              '/steps/' +
              item.id +
              '/submission/' +
              item.dynamicFormSubmissionId
            : 'form/' + fundRaiseApplicationId + '/steps/' + item.id
        "
      >
        {{ 'raise.fillAndSubmit' | translate }}
      </button>
    }
    @if (item.raiseFundApplicationActionType == RaiseFundApplicationActionType.EKYC) {
      <div class="d-flex flex-row align-items-center pending">
        <i class="fa fa-circle mr-3"></i> {{ 'raise.pendingAdminVerification' | translate }}
      </div>
    }
    @if (
      item.campaignId &&
      item.raiseFundApplicationActionType == RaiseFundApplicationActionType.CreateCampaign &&
      item.raiseFundApplicationProcessStatusType != RaiseFundApplicationProcessStatusType.None
    ) {
      <a
        class="btn btn-outline-primary"
        [routerLink]="['/raise/edit-campaign', fundRaiseApplicationId, item.campaignId]"
      >
        {{ 'raise.fillAndSubmit' | translate }}
      </a>
    }
  }
  @if (
    item.raiseFundApplicationProcessStatusType == RaiseFundApplicationProcessStatusType.None &&
    item.raiseFundApplicationActionType == RaiseFundApplicationActionType.OfferCreation
  ) {
    <div class="d-flex flex-row align-items-center pending">
      <i class="fa fa-circle mr-3"></i>
      <div>{{ 'raise.PendingOfferCreation' | translate }}</div>
    </div>
  }
  @if (
    item.raiseFundApplicationActionType == RaiseFundApplicationActionType.FPXPayment &&
    [
      RaiseFundApplicationProcessStatusType.None,
      RaiseFundApplicationProcessStatusType.Rejected,
    ].includes(item.raiseFundApplicationProcessStatusType)
  ) {
    <div class="d-flex align-items-center">
      <button type="btn" class="btn btn-outline-primary" (click)="makePayment()">
        {{ 'raise.makePayment' | translate }}
      </button>
    </div>
  }
  @if (
    [
      RaiseFundApplicationActionType.UploadDocument,
      RaiseFundApplicationActionType.UploadVideo,
      RaiseFundApplicationActionType.UploadCampaignVideo,
    ].includes(item.raiseFundApplicationActionType) &&
    (item.raiseFundApplicationProcessStatusType == RaiseFundApplicationProcessStatusType.None ||
      item.raiseFundApplicationProcessStatusType == RaiseFundApplicationProcessStatusType.Rejected)
  ) {
    @if (
      item.raiseFundApplicationProcessStatusType == RaiseFundApplicationActionType.None &&
      item.sampleAttachmentUrl
    ) {
      <div class="link mb-3 d-md-none" (click)="viewDetails(item.sampleAttachmentUrl)">
        {{ 'raise.downloadTemplate' | translate }}
      </div>
    }
    <div class="input-field">
      @if (!item.attachment || !item.attachmentUrl) {
        <div
          class="document-upload cursor-pointer"
          agmoUploader
          [accept]="getAcceptType(item.raiseFundApplicationActionType)"
          (selectFiles)="selectFile($event, item)"
        >
          <div class="document-text tw-text-center">
            {{
              (item.raiseFundApplicationActionType == RaiseFundApplicationActionType.UploadDocument
                ? 'common.upload'
                : 'common.upload'
              ) | translate
            }}
          </div>
          <!-- <div class="pitchin-icon pitchin-icon-upload"></div> -->
        </div>
      }
      @if (item.attachment && item.attachmentUrl) {
        <div class="document-upload uploaded">
          <div class="document-text">{{ item.attachment.name }}</div>
        </div>
      }
    </div>
  }
  @if (
    item.raiseFundApplicationActionType == RaiseFundApplicationActionType.UploadMultipleFile &&
    item.raiseFundApplicationProcessStatusType != RaiseFundApplicationProcessStatusType.Approved
  ) {
    <div
      class="document-upload cursor-pointer mt-2 tw-text-center"
      (click)="uploadAdditionalDocument(item)"
    >
      <div class="document-text">
        {{ 'common.upload' | translate }}
      </div>
      <!-- <div class="pitchin-icon pitchin-icon-upload"></div> -->
    </div>
  }
  <!-- PLT-1195 Remove ability for issuer to delete the files -->
  <!-- <ng-container
  *ngIf="item.raiseFundApplicationActionType == RaiseFundApplicationActionType.Attachment && item.raiseFundApplicationProcessStatusType != RaiseFundApplicationProcessStatusType.Approved">
  <button class="btn btn-outline-primary" (click)="removeAttachmentByAttachmentId(item.id, parent.id)">
    {{ 'company.deleteDocument' | translate }}
  </button>
</ng-container> -->
</ng-template>

<ng-template #mobilerow let-item="item" let-padding="padding" let-parent="parent">
  <ng-container>
    <div class="d-flex flex-row list-content padding-1 {{ padding }}">
      <div
        class="pitchin-icon-md pitchin-icon-check-grey mr-4"
        [class.pitchin-icon-check-green]="
          [
            RaiseFundApplicationProcessStatusType.Approved,
            RaiseFundApplicationProcessStatusType.Paid,
          ].includes(item.raiseFundApplicationProcessStatusType)
        "
      ></div>
      <div class="w-100">
        <div [innerHTML]="item.title"></div>
        @if (!isDraftItem(item)) {
          <div class="text-black-50">
            {{ item.lastUpdatedDate | amDateFormat: 'DD MMM YYYY, HH:mm a' }}
          </div>
        }
        <div class="mt-2">
          <ng-template *ngTemplateOutlet="detail; context: { item: item }"></ng-template>
        </div>
        <div class="mt-2">
          <ng-template
            *ngTemplateOutlet="action; context: { item: item, parent: parent }"
          ></ng-template>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

@if (!fundRaiseProcess) {
  <agmo-loading></agmo-loading>
}
